// create a fake namespace object
// mode & 1: value is a module id, require it
// mode & 2: merge all properties of value into the ns
// mode & 4: return value when already ns object
// mode & 8|1: behave like require
__webpack_require__.t = function(value, mode) {
	if(mode & 1) value = this(value);
	if(mode & 8) return value;
	if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	var ns = Object.create(null);
	__webpack_require__.r(ns);
	var def = {};
	if(mode & 2 && typeof value == 'object' && value) {
		for(var key in value) def[key] = function(key) { return value[key]; }.bind(null, key);
	}
	def['default'] = function() { return value; };
	__webpack_require__.d(ns, def);
	return ns;
};